// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3cIGV","icon":"SortAdornment_icon__1Emf-","up":"SortAdornment_up__X0Bz7","down":"SortAdornment_down__3TBdg","active":"SortAdornment_active__LGWu5"};